import { render, staticRenderFns } from "./VendorInput.vue?vue&type=template&id=2dfab9dc&scoped=true&"
import script from "./VendorInput.vue?vue&type=script&lang=js&"
export * from "./VendorInput.vue?vue&type=script&lang=js&"
import style0 from "./VendorInput.vue?vue&type=style&index=0&id=2dfab9dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfab9dc",
  null
  
)

/* custom blocks */
import block0 from "./VendorInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports